import React from 'react';
export function CardSkeleton() {
  return <div className="glass-panel p-6 rounded-2xl" data-id="element-368" data-mp="3cslexwltu195">
      <div className="flex items-center justify-between mb-5" data-id="element-369" data-mp="196ho7xvyvp6l">
        <div className="h-3 w-24 shimmer rounded" data-id="element-370" data-mp="197spnr1xwkuj" />
        <div className="h-9 w-9 shimmer rounded-xl" data-id="element-371" data-mp="ui4lmi2dj834" />
      </div>
      <div className="h-8 w-32 shimmer rounded mb-3" data-id="element-372" data-mp="zfwqeco4aooq" />
      <div className="h-3 w-20 shimmer rounded" data-id="element-373" data-mp="zgpm8iljfts3" />
    </div>;
}
export function ChartSkeleton() {
  return <div className="glass-panel p-6 rounded-2xl h-80 flex flex-col" data-id="element-374" data-mp="1n6jxivq7laa8">
      <div className="flex items-center justify-between mb-6" data-id="element-375" data-mp="1s3sh90r09mdl">
        <div className="h-4 w-40 shimmer rounded" data-id="element-376" data-mp="1e5cdniofwbzo" />
        <div className="h-3 w-16 shimmer rounded" data-id="element-377" data-mp="1e4j1u3amiwao" />
      </div>
      <div className="flex-1 flex items-end gap-2" data-id="element-378" data-mp="1i5wb6ncxdhmc">
        {[60, 80, 45, 90, 70, 55, 85, 65].map((h, i) => <div key={i} className="flex-1 shimmer rounded-t" style={{
        height: `${h}%`
      }} data-id="element-379" data-mp="2ouf9d1a7zae" data-mpi={i} />)}
      </div>
    </div>;
}
export function TableSkeleton() {
  return <div className="glass-panel rounded-2xl overflow-hidden" data-id="element-380" data-mp="s6rdw07109vc">
      <div className="h-14 shimmer border-b border-slate-800/60" data-id="element-381" data-mp="n6vhon4klmqc" />
      {[...Array(6)].map((_, i) => <div key={i} className="h-12 border-b border-slate-800/40 flex items-center px-6 gap-4" data-id="element-382" data-mp="116wjc4snsy6v" data-mpi={i}>
          <div className="h-3 w-1/5 shimmer rounded" data-id="element-383" data-mp="x5uen8fz3txi" />
          <div className="h-3 w-1/4 shimmer rounded" data-id="element-384" data-mp="1b2hg9oivf89r" />
          <div className="h-3 w-1/5 shimmer rounded" data-id="element-385" data-mp="164fwf1dmf4x8" />
          <div className="h-3 w-1/6 shimmer rounded" data-id="element-386" data-mp="163mz0r0jxrrr" />
          <div className="h-3 w-1/5 shimmer rounded ml-auto" data-id="element-387" data-mp="1kt2ng0cm1l4a" />
        </div>)}
    </div>;
}